// One-shot reset for the canonical app defaults.
//
// When the owner pins a new ground-truth default (theme = dark, colour
// = blue, font = IBM Plex, voices = Brian + Shakir), existing browsers
// already have their saved choices in localStorage and would otherwise
// keep the old defaults forever. This module runs once per browser at
// app boot, wipes the persisted preference keys, and stamps a version
// flag so it doesn't re-clobber any choice the user makes afterward.
//
// To roll out another defaults change later: bump DEFAULTS_VERSION and
// add any new keys to KEYS_TO_RESET. Older browsers will run the reset
// once on next load; current browsers stay untouched.

const DEFAULTS_VERSION = 2
const VERSION_KEY = 'routine-app-defaults-version'

// Every localStorage key that holds a user-customisable preference
// affected by the v2 defaults rollout (theme mode, auto-by-time flag,
// accent palette, app font, TTS voices for EN + AR).
const KEYS_TO_RESET = [
  'routine-app-theme',
  'routine-app-theme-auto',
  'routine-app-palette',
  'phoenix:app-font',
  'phoenix:tts-voice-en',
  'phoenix:tts-voice-ar',
]

export function maybeResetDefaults() {
  if (typeof window === 'undefined') return
  try {
    const stored = parseInt(window.localStorage.getItem(VERSION_KEY) || '0', 10)
    if (stored >= DEFAULTS_VERSION) return
    for (const key of KEYS_TO_RESET) window.localStorage.removeItem(key)
    window.localStorage.setItem(VERSION_KEY, String(DEFAULTS_VERSION))
  } catch { /* private mode / storage blocked — fall through silently */ }
}
